<div class="container">
	<h4>Review Dates</h4>
	<hr />

	<div class="form-inline mb-3" *ngIf="!creating">
		<label class="mr-2 text-muted small mb-0">Period of review ending in</label>
		<select #yearSelect="ngModel" class="form-control form-control-sm mr-2"
			[ngModel]="selectedYear"
			(ngModelChange)="onYearChange($event)"
			[disabled]="years.length === 0">
			<option *ngFor="let y of years" [ngValue]="y">{{ y - 1 }}</option>
		</select>
		<button class="btn btn-sm btn-outline-primary" (click)="startCreate()">
			<i class="fa fa-plus"></i> New Year…
		</button>
	</div>

	<div class="card mb-3" *ngIf="creating">
		<div class="card-body">
			<h5 class="card-title">Set up a new year</h5>
			<div class="row">
				<div class="col-sm-4">
					<label class="text-muted small mb-1">Year (period of review ending in)</label>
					<input class="form-control form-control-sm" type="number"
						[(ngModel)]="newYearInput"
						[ngModelOptions]="{standalone: true}" />
				</div>
				<div class="col-sm-4">
					<label class="text-muted small mb-1">Clone dates from (optional)</label>
					<select class="form-control form-control-sm"
						[(ngModel)]="cloneSourceYear"
						[ngModelOptions]="{standalone: true}">
						<option [ngValue]="null">— start blank —</option>
						<option *ngFor="let y of years" [ngValue]="y">{{ y - 1 }}</option>
					</select>
				</div>
			</div>
			<div class="mt-3">
				<button class="btn btn-sm btn-primary" (click)="confirmCreate()">Create</button>
				<button class="btn btn-sm btn-link" (click)="cancelCreate()">Cancel</button>
			</div>
		</div>
	</div>

	<div *ngIf="selectedYear !== null && !loading">
		<table class="table table-sm table-bordered" style="background: white;">
			<thead>
				<tr>
					<th>Milestone</th>
					<th style="width: 180px;">Date</th>
					<th>Days from open</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of rows; let i = index">
					<td>{{ row.milestone.displayName }}</td>
					<td>
						<div class="d-flex align-items-center">
							<input class="form-control form-control-sm"
								[class.is-invalid]="dateNg.errors?.matDatepickerParse"
								[matDatepicker]="picker"
								[(ngModel)]="row.date"
								[ngModelOptions]="{standalone: true}"
								[name]="'date-' + row.milestone.key"
								placeholder="MM/DD/YYYY"
								#dateNg="ngModel" />
							<mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
							<mat-datepicker #picker [startAt]="startAt(i)"></mat-datepicker>
						</div>
						<div *ngIf="dateNg.errors?.matDatepickerParse" class="text-danger small mt-1">
							Invalid date
						</div>
					</td>
					<td>
						<ng-container *ngIf="row.referenceOpen as openMilestone">
							<ng-container *ngIf="daysFromOpen(row) !== null; else noDays">
								{{ daysFromOpen(row) }} days from {{ openMilestone.displayName }}
							</ng-container>
							<ng-template #noDays>
								<span class="text-muted small">—</span>
							</ng-template>
						</ng-container>
					</td>
				</tr>
			</tbody>
		</table>

		<button class="btn btn-primary" (click)="save()" [disabled]="saving || hasInvalidDate">
			{{ saving ? 'Saving…' : 'Save' }}
		</button>
		<span *ngIf="hasInvalidDate" class="text-danger small ml-2">
			Fix invalid dates before saving.
		</span>
	</div>

	<div *ngIf="selectedYear === null && !creating" class="text-muted">
		No review dates configured yet. Click <strong>New Year…</strong> to get started.
	</div>
</div>
